module.exports = __webpack_public_path__ + "static/media/vf_wtshirts_core.0bd3b6e4.svg";